module.exports = __webpack_public_path__ + "img/productinfo-4.fb28dd1c.jpg";